import React, { Fragment, useEffect, useState } from "react";
import styled from "styled-components";
import MissionsList from "../../MissionsList";
import ItemMission from "../../MissionsList/ItemMission";
import iconDailyLogin from "../../../../../../assets/images/Mini-Game/icon-daily-login.svg";
import iconPlace3Turns from "../../../../../../assets/images/Mini-Game/icon-place-3-turns.svg";
import PATH from "../../../../../../config/PATH";
import { useNavigate } from "@hooks/useNavigate";
import iconBuyBid from "../../../../../../assets/images/Mini-Game/icon-buy-bid.svg";
import iconChangeCoins from "../../../../../../assets/images/Mini-Game/icon-change-coins.png";
import { useMiniGameAuth } from "@pages/Events/MiniGame/store";
import { ID_TAB_MINI_GAME } from "../../../../../../helper/const";
import { useTranslation } from "react-i18next";

export default function MissionEarnCoins({
  missionMiniClick = () => { },
  setStep,
  buttonAction,
  turn,
  handleValueInput,
  isSmall = false,
  onCancel,
  setOpenPopupChangeCoin,
  setTurn
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [bidTotal, setBidTotal] = useState(0);
  const { isAuthenticated, remainTurn, requireLogin } = useMiniGameAuth();

  useEffect(() => {
    if (remainTurn?.length) {
      const total = remainTurn
        ?.filter((pack) => pack?.type !== 1)
        ?.reduce((acc, pack) => acc + pack?.turn, 0);
      setBidTotal(total);
    }
  }, [remainTurn]);
  const dailyMissions = [
    {
      id: 1,
      icon: iconDailyLogin,
      name: t("mini_game.pop_up_earn_more.mission_to_earn"),
      status: "execute",
      titleFooter: t("mini_game.pop_up_earn_more.complete_to_earn"),
      link: `${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.collectPiece}`,
      isEarnMore: true,
    },

    {
      id: 2,
      icon: iconBuyBid,
      name: "Buy more coins",
      status: "execute",
      titleFooter: "Buy with Sub or Retail packages",
      link: "/account/package",
      contentButton: "Buy",
      isEarnMore: true,
    },
  ];

  const handleChangeTurn = () => {
    if (!requireLogin()) {
      return;
    }
    if (onCancel) {
      onCancel();
    }
    setStep("change Coins");
    missionMiniClick();
    setOpenPopupChangeCoin(true)

  };

  const handleInputBid = (e) => {
    const value = e.target.value;

    if (value === "") {
      setTurn(1);
      return;
    }

    const num = Number(value);

    if (isNaN(num)) return;

    if (num < 1) {
      setTurn(1);
      return;
    }

    if (num > 100) {
      setTurn(100);
      return;
    }

    setTurn(num);
  };

  return (
    <Container isSmall={isSmall}>
      <ItemMission data={dailyMissions[0]} isDaily onCancel={onCancel} />
      <ItemMission
        isShowWarning={isAuthenticated ? turn > bidTotal : false}
        isChangeCoins
        contentWarning={
          bidTotal === 0
            ? t("you_have_no_bids_left_to_change")
            : t("the_number_of_coins_must_not_exceed_the_number_of_bids")
        }
      >
        <div className="change-turn">
          <div className="btn-container">
            <button onClick={() => buttonAction("minus")}>-</button>
            <input className="btn-total"
              value={turn}
              type="number"
              inputMode="numeric"
              min={1}
              max={100}
              onChange={handleInputBid}
            />
            <button onClick={() => buttonAction("add")}>+</button>
          </div>
          <button
            className={`btn-change-turn ${bidTotal === 0 || turn > bidTotal ? "disable-btn" : ""}`}
            onClick={handleChangeTurn}
          >
            {`${t("mini_game.standard_missions.change_turns")
              .replace("X", turn)
              .replace("turns", +turn > 1 ? "turns" : "turn")}`}
          </button>
        </div>
      </ItemMission>
      {/* <ItemMission data={dailyMissions[1]} isDaily /> */}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .btn-container{
    background: #fff;
    border-radius: 25px;
    .btn-total{
      border: none;
      outline: none;
      background: #fff;
      max-width: 90px;
      width: 100%;
    }
    @media (max-width: 768px) {
        height: 35px;
      }
   button {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 2px solid transparent;

      background:
        linear-gradient(white, white) padding-box,
        linear-gradient(
          90deg,
          rgba(24, 56, 197, 1),
          rgba(1, 123, 248, 1)
        ) border-box;

      @media (max-width: 768px) {
        width: 35px;
        height: 35px;
      }
    }
  }


  .disable-btn {
    pointer-events: none;
    background-color: #d0d5dd !important;
    border: 1px solid #d0d5dd;
    color: #98a2b3;
  }

  .warning-change-turn {
    position: relative;
    width: 100%;
    background-color: transparent;
    padding: 10px;
    text-align: center;
    border-radius: 8px;
    color: #d92d20;
    font-style: italic;
    margin-top: 16px;
    text-wrap: stable;

    div {
      color: #2970ff;
      font-weight: 500;
      text-decoration: underline;
      cursor: pointer;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .change-turn {
    margin-top: 14px;
    grid-template-columns: auto;
  }

  .container-change-coins-mini {
    display: flex;
    justify-content: space-between;
    position: relative;

    .btn-change-turn {
      font-size: 16px;
      position: absolute;
      bottom: 50%;
      transform: translateY(50%);
      width: 100px;
      right: 0;
      color: #fff;

      @media (min-width: 1200px) {
        right: 20px;
        width: 120px !important;
        max-height: 48px !important;
      }

      &:hover {
        scale: 1.05;
        transition: all 0.3s ease-in-out;
      }

      @media (max-width: 625px) {
        font-size: 14px;
      }

      @media (max-width: 576px) {
        padding: 12px;
      }

      @media (max-width: 475px) {
        font-size: 12px;
        width: 135px;
      }

      @media (max-width: 468px) {
        width: fit-content;
      }

      @media (max-width: 425px) {
        padding: 12px;
      }
    }
  }

 
  

  .excute-daily {
    background: linear-gradient(90deg, #d85f14 0%, #ff9204 100%);
    color: white;
    font-size: 16px;
    border-radius: 6px;

    @media (max-width: 625px) {
      font-size: 14px;
    }

    @media (max-width: 475px) {
      font-size: 12px;
      width: 100%;
    }
  }

  ${(props) =>
    props.isSmall
      ? `
        .excute-daily {
          font-size: 14px;

          @media (max-width: 768px) {
            font-size: 12px;
            width: 70px;
          }
        }
        .btn-change-turn {
          font-size: 14px!important;

          @media (max-width: 768px) {
            font-size: 12px!important;
          }

          @media (max-width: 392px) {
            height: 40x;
          }
        }   `
      : ``}/* @media (max-width: 400px) {
    .btn-change-turn {
      max-width: 125px;
      line-height: 17px;
    }
  } */
`;
